import { render, staticRenderFns } from "./16zhihuidangjian.vue?vue&type=template&id=2cb6e4f5&scoped=true&"
import script from "./16zhihuidangjian.vue?vue&type=script&lang=js&"
export * from "./16zhihuidangjian.vue?vue&type=script&lang=js&"
import style0 from "./16zhihuidangjian.vue?vue&type=style&index=0&id=2cb6e4f5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb6e4f5",
  null
  
)

export default component.exports